import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  consumableSupply_pack,
  consumableSupply_rolls,
} from '../../../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';

export default function MissouriSupplySelectForm({
  supplySelections,
  setForm,
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      supplySelections: {
        ...prevForm.supplySelections,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash Pop Playslip'}</InputLabel>
          <Select
            value={supplySelections.cashPopPlay}
            label={'Cash Pop Playslip'}
            onChange={handleChange}
            name='cashPopPlay'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Lotto Playslip'}</InputLabel>
          <Select
            value={supplySelections.lotto}
            label={'Lotto Playslip'}
            onChange={handleChange}
            name='lotto'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Mega Millions Playslip'}</InputLabel>
          <Select
            value={supplySelections.megaMillions}
            label={'Mega Millions Playslip'}
            onChange={handleChange}
            name='megaMillions'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Millionaire For Life Playslip'}</InputLabel>
          <Select
            value={supplySelections.millionaireForLife}
            label={'Millionaire For Life Playslip'}
            onChange={handleChange}
            name='millionaireForLife'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'MO Millions Playslip'}</InputLabel>
          <Select value={supplySelections.moMillions} label={'MO Millions Playslip'} onChange={handleChange} name='moMillions'>
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'New Keno Refresh Playslip'}</InputLabel>
          <Select
            value={supplySelections.newKenoRefresh}
            label={'New Keno Refresh Playslip'}
            onChange={handleChange}
            name='newKenoRefresh'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Pick 3 Playslip'}</InputLabel>
          <Select
            value={supplySelections.pick3}
            label={'Pick 3 Playslip'}
            onChange={handleChange}
            name='pick3'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Pick 4 Playslip'}</InputLabel>
          <Select
            value={supplySelections.pick4}
            label={'Pick 4 Playslip'}
            onChange={handleChange}
            name='pick4'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerball}
            label={'Powerball Playslip'}
            onChange={handleChange}
            name='powerball'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball X\'s & O\'s Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerballXsOs}
            label={'Powerball X\'s & O\'s Playslip'}
            onChange={handleChange}
            name='powerballXsOs'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Show Me Cash Playslip'}</InputLabel>
          <Select
            value={supplySelections.showMeCash}
            label={'Show Me Cash Playslip'}
            onChange={handleChange}
            name='showMeCash'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Ticket Stock (Printer Paper)'}</InputLabel>
          <Select
            value={supplySelections.ticketStock}
            label={'Ticket Stock (Printer Paper)'}
            onChange={handleChange}
            name='ticketStock'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
